// Layout for /onboarding/* — auth-gates the subtree and provides shared
// chrome (cream background, max-w container). Step counters are computed
// per-screen from the kid's actual data so they stay accurate as Sprint 4
// adds steps.

import { createFileRoute, Outlet } from "@tanstack/react-router";
import { BootGate } from "@/components/BootGate";
import { ParentRouteError } from "@/components/RouterErrorFallback";

export const Route = createFileRoute("/onboarding")({
  errorComponent: ParentRouteError, // MA-107
  head: () => ({ meta: [{ title: "PencilWise · Setup" }] }),
  component: () => (
    <BootGate surface="kid">
      <Outlet />
    </BootGate>
  ),
});
